'use client';

import { useSyncExternalStore } from 'react';
import { isNative } from './index';

const subscribe = () => () => undefined;
const serverSnapshot = () => false;

/**
 * Capacitor's platform is fixed for the life of the page. The server snapshot
 * stays false so remote-web SSR hydrates cleanly; React checks the client
 * snapshot immediately after hydration and removes web-only purchase actions
 * before the native splash screen is dismissed.
 */
export function useIsNative(): boolean {
  return useSyncExternalStore(subscribe, isNative, serverSnapshot);
}
